import { Line } from 'react-chartjs-2'
import { colorPalette } from '../../utils/color-utils';
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'

// Register Chart.js components and plugins
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
)

export default function ChartDay({ data, title }: any) {
    const labels = data[0]?.days?.map((item: any) => item.day)

    const datasets = data.map((item: any, index: any) => ({
        label: item.month,
        data: item.days?.map((day: any) => day.sum),
        borderColor: colorPalette[index % colorPalette.length],
        backgroundColor: colorPalette[index % colorPalette.length],
        borderWidth: 2,
        pointRadius: 4,
        pointBackgroundColor: colorPalette[index % colorPalette.length],
        tension: 0.3,
        hidden: data.length - index > 2,
    }))

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                display: true,
                color: (context: any) => {
                    // Use the same color as the dataset
                    return context.dataset.backgroundColor;
                },
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                borderRadius: 4,
                font: {
                    weight: 'bold',
                    size: 11,
                },
                padding: {
                    top: 2,
                    bottom: 2,
                    left: 4,
                    right: 4,
                },
                anchor: 'end',
                align: 'top',
                offset: 8,
                formatter: (value: any) => value === 0 ? '' : value,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    } as any

    return (
        <Line data={{ labels, datasets }} options={options} />
    )
}
